"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactJss = require("react-jss");
var _ThemeProviderElement = _interopRequireDefault(require("../ThemeProvider/ThemeProviderElement"));
var _excluded = ["children"];
/**
 * @copyright
 * Copyright (c) 2023 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var GlobalStyles = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_ThemeProviderElement.default, _extends({
    ref: ref,
    className: classes.root
  }, props), children);
});

/**
 * Most of the styles copied from old TypographyStyles:
 * https://stash.atg-corp.com/projects/UX/repos/icf.react.components/browse/src/components/TypographyStyles.tsx
 * Extended with good defaults.
 */
GlobalStyles.displayName = "GlobalStyles";
var useStyles = (0, _reactJss.createUseStyles)(function (theme) {
  return {
    root: {
      boxSizing: "border-box"
    },
    "@global": {
      "*, *::before, *::after": {
        boxSizing: "inherit"
      },
      "*": {
        margin: 0
      },
      body: {
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeight,
        fontSize: theme.typography.fontSize,
        color: theme.colors.baseContrast090,
        background: theme.colors.pageBackground,
        "@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 2dppx)": {
          WebkitFontSmoothing: "antialiased",
          MozOsxFontSmoothing: "grayscale"
        }
      },
      a: {
        textDecoration: "none",
        color: theme.colors.primary
      },
      'button, [role="button"]': {
        cursor: "pointer",
        fontFamily: theme.typography.fontFamily
      },
      ":disabled": {
        cursor: "default"
      },
      img: {
        flexShrink: 0
      }
    }
  };
});
var _default = exports.default = GlobalStyles;